import { HttpErrorResponse } from '@angular/common/http';

/**
 * The code the backend puts at the start of a 400 message when it refuses to start a seated payment because a
 * seat of the order is no longer held by the cart (the hold lapsed, and the seat may already be someone
 * else's), or is about to lapse.
 */
export const SEAT_HOLD_EXPIRED = 'SEAT_HOLD_EXPIRED';

const FALLBACK_MESSAGE = 'Your seat reservation has expired. Please choose your seats again.';

type ErrorLike = Pick<HttpErrorResponse, 'status' | 'error'> | null | undefined;

function messageOf(error: ErrorLike): string {
  let body: unknown = error?.error;
  if (typeof body === 'string') {
    try {
      body = JSON.parse(body);
    } catch {
      return body as string;
    }
  }
  const message = (body as { message?: unknown } | null)?.message;
  return typeof message === 'string' ? message : '';
}

/** A seated payment refused because the seat hold lapsed: the buyer cannot pay and has to choose again. */
export function isSeatHoldExpired(error: ErrorLike): boolean {
  return error?.status === 400 && messageOf(error).includes(SEAT_HOLD_EXPIRED);
}

/** The sentence written for the buyer, without the code the backend puts in front of it. */
export function seatHoldExpiredMessage(error: ErrorLike): string {
  const text = messageOf(error).replace(new RegExp(`^.*?${SEAT_HOLD_EXPIRED}:?\\s*`), '').trim();
  return text || FALLBACK_MESSAGE;
}
